import React, {Component} from 'react';
import { tryUpdateDailySalary } from 'actions/UserActions';
import SalaryAdjustModal from './SalaryAdjustModal';
import PayrollModal from './PayrollModal';
import ConfirmDialog from 'components/Dialog/Confirm';

import moment from 'moment';

const DailySalaryShow = ({dailySalary, activeEditDS}) => (
  <td>${dailySalary}
    <a onClick={activeEditDS} className="btn salary__action">
      調整
    </a>
  </td>
);

const DailySalaryEdit = ({editSalary, editSalaryChange, dismissEditDS, updateDailySalary}) => (
  <td>{"$ "}
    <input
      className="form-control salary__input"
      value={editSalary}
      onChange={editSalaryChange}
    />
    <a onClick={updateDailySalary} className="btn salary__action">
      儲存
    </a>
    <a onClick={dismissEditDS} className="btn salary__action">
      取消
    </a>
  </td>
);

class Salary extends Component {
  state = {
    editDailySalary: false,
    editSalaryAdjust: false,
    confirmToPay: false,
    editSalary: 0,
  }

  activePayroll = () => {
    this.setState({
      confirmToPay: true
    })
  }

  activePayrollWithWarning = () => {
    return () => {
      ConfirmDialog("還有未確認出席的簽到記錄，是否仍繼續出糧？")
        .then(
          () => {
            this.activePayroll()
          },
          () => {
    
          }
        )
    }
  }

  dismissPayroll = () => {
    this.setState({
      confirmToPay: false
    })
  }

  activeEditDS = () => {
    this.setState({
      editDailySalary: true,
      editSalary: this.props.dailySalary
    })
  }

  dismissEditDS = () => {
    this.setState({
      editDailySalary: false
    })
  }

  activeAdjustSalary = () => {
    this.setState({
      editSalaryAdjust: true
    })
  }

  dimissAdjustSalary = () => {
    this.setState({
      editSalaryAdjust: false
    })
  }

  handleEditSalaryChange = (e) => {
    this.setState({
      editSalary: e.target.value
    })
  }

  handleUpdateDailySalary = () => {
    this.props.dispatch(tryUpdateDailySalary(
      this.props.dailySalary, this.state.editSalary
    ));
    this.dismissEditDS();
  }

  getAdjustAmount = () => {
    let {salaryAdjust} = this.props;
    let final = 0;
    salaryAdjust.entrySeq().forEach(([id, data]) => {
      let amount = data.get('amount')
      final += amount;
    })

    return final;
  }

  render() {
    let {editDailySalary, editSalaryAdjust, editSalary, confirmToPay} = this.state;
    let {dailySalary, salaryAdjust, dispatch, shiftRecord, sessionConfig, adjustmentTypeList} = this.props;
    let OTConfig = sessionConfig.get(2);
    let minPerShift = OTConfig.get('minPerShift');
    let minWorkTime = OTConfig.get('minWorkTime');
    let normalShift = 0, otShift = 0;
    let shiftPayRecord = {};
    let hasNotConfirmCheckin = false;

    if (shiftRecord)
      shiftRecord.forEach((item, key) => {
        let confirmed = item.get('confirmAt') !== null;
        let hasCheckin = item.getIn(['checkRecords', 0, 'checkAt']) !== null && item.getIn(['checkRecords', 0, 'status']) === 0;
        if (item.get('checkRecords').size > 1) 
          hasCheckin = 
            hasCheckin 
            && item.getIn(['checkRecords', 1, 'checkAt']) !== null 
            && item.getIn(['checkRecords', 1, 'status']) === 0;
        
        if (hasCheckin && !confirmed) hasNotConfirmCheckin = true;

        if (confirmed) {
          let sid = item.get('sid');
          let site_name = item.get('site_name');
          let tmpCount = 0;
          if (sid < 2) {
            normalShift += sessionConfig.get(sid).get('workUnit');
            shiftPayRecord[key] = site_name;
          } else{
            let checkAt = item.getIn(['checkRecords', 0, 'checkAt']);
            let status = item.getIn(['checkRecords', 0, 'status']);
            let checkOut = item.get('checkRecords').size > 1 && item.getIn(['checkRecords', 1, 'checkAt']);
            status = status || (item.get('checkRecords').size > 1 && item.getIn(['checkRecords', 1, 'status']));
            if (checkAt !== null && checkOut && status === 0 ) {
              checkAt = moment(checkAt, 'YYYY-MM-DD HH:mm:ss');
              checkOut = moment(checkOut, 'YYYY-MM-DD HH:mm:ss');
              let OTWorkUnitPerShift = OTConfig.get('workUnitPerShift');
              let OTduration = moment.duration(checkOut.diff(checkAt));
              let minsOfOT = OTduration.hours() * 60 + OTduration.minutes();
              let shiftNumber = ~~(minsOfOT / minPerShift) + (minsOfOT % minPerShift > minWorkTime? 1 : 0);
              tmpCount = (shiftNumber * OTWorkUnitPerShift);
            }
            let otOffset = item.get('otOffset') || 0;
            let tmpOtShit = (otOffset + tmpCount);
            tmpOtShit = (tmpOtShit > 0 ? tmpOtShit : 0)
            otShift += tmpOtShit;
            if (tmpOtShit > 0)
              shiftPayRecord[key] = site_name + '(' + tmpOtShit + ')';
          }
        }

        if (item.get('cid') < 0) {
          shiftPayRecord[key] = item.get('site_name');
        }

      })

    return (
      <div className="result salary">
        <table className="table">
          <thead>
            <tr>
              <th>日薪</th>
              <th>總工數</th>
              <th>借糧/花紅</th>
              <th>總月薪</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {(editDailySalary?
                <DailySalaryEdit
                  editSalary={editSalary}
                  editSalaryChange={this.handleEditSalaryChange}
                  dismissEditDS={this.dismissEditDS}
                  updateDailySalary={this.handleUpdateDailySalary}
                />
              : <DailySalaryShow
                  dailySalary={dailySalary}
                  activeEditDS={this.activeEditDS}
                /> )}
              <td>{normalShift + otShift}</td>
              <td>
                ${this.getAdjustAmount()}
                <a className="btn salary__action" onClick={this.activeAdjustSalary}>
                  處理
                </a>
              </td>
              <td>
                ${(normalShift + otShift) * dailySalary + this.getAdjustAmount()}
                <a className="btn salary__action" onClick={(hasNotConfirmCheckin? this.activePayrollWithWarning() : this.activePayroll)}>
                  <span className="glyphicon glyphicon-piggy-bank"></span>
                  出糧
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        {editSalaryAdjust &&
          <SalaryAdjustModal adjustList={salaryAdjust} adjustmentTypeList={adjustmentTypeList} dimissAdjustSalary={this.dimissAdjustSalary} dispatch={dispatch}/>}
        {confirmToPay &&
          <PayrollModal 
            normalShift={normalShift}
            otShift={otShift}
            shiftPayRecord={shiftPayRecord}
            {...this.props} 
            dismiss={this.dismissPayroll} />}
      </div>
    )
  }
}

export default Salary;



// WEBPACK FOOTER //
// ./src/components/Salary/Salary.js